import React from 'react';
import tpl from '../templates/digital-skins';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    shouldFetchData() {
        return false;
    }

    static displayName = 'DigitalSkins';
}
